/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVUpIcon20Light = forwardRef('DataChartBarsXyVUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.5 3a.5.5 0 0 1 .5.5v12A1.5 1.5 0 0 0 4.5 17h14a.5.5 0 0 1 0 1h-14A2.5 2.5 0 0 1 2 15.5v-12a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M6.5 10.25a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0v-3.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M13 6a.5.5 0 0 0-1 0v8.219a.5.5 0 0 0 1 0V6Z" }),
        React.createElement("path", { d: "M15.5 3a.5.5 0 0 1 .5.5v10.719a.5.5 0 0 1-1 0V3.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M10 8.35a.5.5 0 1 0-1 0v5.869a.5.5 0 0 0 1 0V8.35Z" })));
});
